// src/components/Icon.js
import { C } from '../styles/theme';

export function HeartIcon({ filled, size = 20, color = C.roseDark }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24"
      fill={filled ? color : 'none'} stroke={color} strokeWidth="1.8">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

export function NavIcon({ path, active, size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={active ? C.roseDark : C.text} strokeWidth="1.7"
      strokeLinecap="round" strokeLinejoin="round">
      <path d={path}/>
    </svg>
  );
}

export function LogoMark({ size = 48 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100">
      <path d="M50 12 L82 28 L82 72 L50 88 L18 72 L18 28 Z"
        fill="none" stroke={C.rose} strokeWidth="3.5" strokeLinejoin="round"/>
      <ellipse cx="50" cy="50" rx="22" ry="28" fill="none" stroke={C.lilas} strokeWidth="3"/>
      <path d="M38 36 Q50 56 62 36" fill="none" stroke={C.peach} strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M34 58 Q50 46 66 58" fill="none" stroke={C.rose}  strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
}
